export function downloadFileByByteArray(data, fileName, fileExtension) {
  const blob = new Blob([data], { type: fileExtension })
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = fileName
  link.click()
}
